export const attachmentFields = {
    photos: [],
    schemas: [],
    technicalFiles: [],
    reports: [],
    others: [],
};
